class SaveLocationDto {
  id?: string;
  name!: number;
  areaId!: string;
  sectionId!: string;
  active!: boolean;
}

export default SaveLocationDto;
